import _ from 'lodash';
import meetingState from '../../../data/constants/meetingState';

export default function (state, action) {
    if (!state) {
        state = {
            loaded: false,
            fetchTime: null,
            organized: [], // TODO: replace this with on demand filtered/memoized hooks
            invited: [], // TODO: replace this with on demand filtered/memoized hooks
            all: [],
            unconfirmedMeetings: 0,
        };
    }

    switch (action.type) {
        case 'EVENT_MEETINGS_LOADED':
            state = Object.assign({}, state, {
                loaded: true,
                fetchTime: action.fetchTime,
                organized: action.meetings.organized,
                invited: action.meetings.invited,
                all: _.uniqBy([...action.meetings.organized, ...action.meetings.invited], 'id'),
            });
            _(state.all).each(meeting => {
                setMeetingCalculatedFields(action.userId, meeting);
            });
            _(state.organized).each(meeting => {
                meeting._organized = true;
            });
            break;
        case 'EVENT_MEETING_CREATED':
            state = Object.assign({}, state);
            let meeting = Object.assign({}, action.meeting, {
                _organized: action.meeting.initiator.id == action.userId,
            });
            setMeetingCalculatedFields(action.userId, meeting);
            if (meeting._organized) {
                state.organized = [...state.organized, meeting];
            } else {
                state.invited = [...state.invited, meeting];
            }
            state.all = [...state.all, meeting];
            break;

        case 'EVENT_MEETING_CHANGED':
            state = Object.assign({}, state);
            setMeetingCalculatedFields(action.userId, action.meeting);

            let replaceMeeting = meeting => {
                    if (meeting.id == action.meeting.id) {
                        return {
                            ...meeting,
                            ...action.meeting,
                        };
                    }
                    return meeting;
                },
                invited = state.invited.map(replaceMeeting);
            state = Object.assign({}, state, {
                all: state.all.map(replaceMeeting),
                organized: state.organized.map(replaceMeeting),
                invited,
                unconfirmedMeetings: invited.filter(meeting => meeting._state == meetingState.PENDING).length,
            });
            if (_.includes(state.organized, action.meeting)) {
                action.meeting._organized = true;
            }
            break;
        case 'EVENT_MEETING_SLOT_BLOCK':
            state = {
                ...state,
                all: state.all.map(meeting => (meeting.id == action.meetingId ? {...meeting, blocked: action.blocked} : meeting)),
            };
            break;
        case 'SESSION_UPDATES':
            state = {
                ...state,
                unconfirmedMeetings: action.eventUpdates.unconfirmed_meetings,
            };
            break;
    }

    return state;
}

// TODO: stop having this pre-calculation and use a memoizes function to do it
const setMeetingCalculatedFields = (myUserId, meeting) => {
    meeting._state = meetingState.PENDING;
    if (meeting.cancelled) {
        meeting._state = meetingState.CANCELLED;
    } else {
        let someoneConfirmed = !!_(meeting.invited).find({state: meetingState.CONFIRMED});
        if (someoneConfirmed) {
            meeting._state = meetingState.CONFIRMED;
        } else {
            if (_(meeting.invited).filter({state: meetingState.CANCELLED}).value().length == meeting.invited.length) {
                meeting._state = meetingState.CANCELLED;
            }
        }
    }
    meeting._myInvite = _(meeting.invited).find({user_id: myUserId});
};
